import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { useContents } from "../../hooks/useContents";
import { imgUrl } from "../../lib/api";

const Block = ({ image, overline, title, text, cta, page, testid }) => (
  <div data-testid={`audience-${testid}`} className="group relative min-h-[420px] lg:min-h-[520px] overflow-hidden border border-steel flex">
    <img
      src={image}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.4s] group-hover:scale-105"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-base via-base/70 to-base/30" aria-hidden="true" />
    <div className="relative mt-auto p-7 sm:p-10 w-full">
      <p className="overline-label">{overline}</p>
      <h3 className="font-display font-bold text-2xl sm:text-3xl uppercase tracking-tight text-white mt-3">{title}</h3>
      <p className="text-metal/85 text-sm sm:text-base leading-relaxed mt-4 max-w-md">{text}</p>
      <div className="mt-7 flex flex-wrap items-center gap-4">
        <Link to="/contatti" data-testid={`audience-cta-${testid}`} className="btn-primary !px-6 !py-3">
          {cta} <ArrowRight size={15} />
        </Link>
        <Link to={page} data-testid={`audience-more-${testid}`} className="inline-flex items-center gap-1.5 text-[12px] font-semibold uppercase tracking-[0.16em] text-metal/80 hover:text-forest-glow transition-colors">
          Scopri di più <ArrowUpRight size={14} />
        </Link>
      </div>
    </div>
  </div>
);

export const SplitAudience = () => {
  const c = useContents();
  return (
  <section data-testid="audience-section" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHeading
        number="06"
        overline="Per chi lavoriamo"
        lines={["Privati e aziende"]}
        description="Lo stesso metodo e la stessa cura, per la tua casa o per la tua impresa."
      />
      <div className="mt-12 lg:mt-16 grid lg:grid-cols-2 gap-5">
        <Reveal>
          <Block
            image={imgUrl(c("privati_img", "/images/privati.jpg"))}
            overline="Edilizia residenziale"
            title="Privati"
            text="Per chi vuole ristrutturare, migliorare o trasformare la propria casa."
            cta="Parla con noi"
            page="/privati"
            testid="privati"
          />
        </Reveal>
        <Reveal delay={0.12}>
          <Block
            image={imgUrl(c("aziende_img", "/images/aziende.jpg"))}
            overline="Edilizia per imprese"
            title="Aziende"
            text="Per imprese, aziende, professionisti e realtà che necessitano di un partner affidabile per lavorazioni edili e gestione delle attività di cantiere."
            cta="Collabora con noi"
            page="/aziende"
            testid="aziende"
          />
        </Reveal>
      </div>
    </div>
  </section>
  );
};
